import React from 'react';

/**
 * Phase 5.0B FINAL — MidfieldDrawBall.
 *
 * CLEAN presentation only. Contains ONLY:
 *   • one interactive Draw hit target
 *   • the raw `ball_skin_default.png`
 *   • the SAME external onClick handler the caller already used
 *   • self-scale pulse (transform: scale(1.00) -> 1.04 -> 1.00, 1.45s)
 *   • a small `DRAW` DOM label below the ball (real text, not baked)
 *
 * The label uses the same existing Draw availability location as the
 * whole button — no second Draw-state calculation exists here.
 *
 * ZERO:
 *   • ball_active_glow
 *   • pseudo-element halo
 *   • outer ring / animated wrapper ring
 *   • fire / trail / particles
 *   • box-shadow glow
 *   • opacity / brightness animation
 */
export default function MidfieldDrawBall({
  onClick, testId, ariaLabel = 'Draw card',
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      aria-label={ariaLabel}
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        // Visible ball is 54px (via .kk-draw-ball); invisible touch
        // target width is 72px so mobile taps stay comfortable.
        width: 72,
        padding: 0,
        margin: 0,
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        touchAction: 'manipulation',
      }}
    >
      <img
        src="/gameplay/ball_skin_default.png"
        alt=""
        aria-hidden
        draggable={false}
        className="kk-draw-ball"
      />
      <span className="kk-draw-ball-label" aria-hidden>DRAW</span>
    </button>
  );
}
